/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for FmsApi services
 */
@Injectable({
  providedIn: 'root',
})
export class FmsApiConfiguration {
  rootUrl: string = '';
}

export interface FmsApiConfigurationInterface {
  rootUrl?: string;
}
